import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class MobyDick1PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.MOBY_DICK1;
}

export default MobyDick1PoiTileEntity;
